module.exports = __webpack_public_path__ + "static/media/level3-2c.eef3eda4.mp3";